// extracted by mini-css-extract-plugin
export var highlightFade = "_2j-4";
export var highlighted = "_2j-3";
export var table = "_2j-1";
export var tableContainer = "_2j-0";
export var totalsRow = "_2j-2";